import ImageAssetUploader from "./image-asset-uploader";
import VideoAssetUploader from "./video-asset-uploader";
import MediaAssetUploader from "./media-asset-uploader";
export var AssetUploader = {
  Image: ImageAssetUploader,
  Video: VideoAssetUploader,
  Media: MediaAssetUploader
};
export default AssetUploader;
//# sourceMappingURL=index.js.map